// extracted by mini-css-extract-plugin
module.exports = {"dialog":"main-baseline__dialog--3bDZX"};